import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react";
import { Col, Menu, Row, message } from "antd";
import { BookOutlined, ShoppingCartOutlined, UserAddOutlined } from "@ant-design/icons";
import { useDevice } from "../../hooks";
import { fetchAllByUser } from "../../api/affiliate";
import RowAffiliate from "../../section/rowAffiliate";

export default function Affiliate() {
    const { isMobile } = useDevice();
    const navigate = useNavigate();
    const [affiliate, setAffiliate] = useState([]);
    const [paginationBook, setPaginationBook] = useState({
      page: 1,
      pageSize: 5,
    });
    const user = JSON.parse(localStorage.getItem("user"));

    const items = [
        {
          key: 'order',
          label: <a href="/thong-tin-ca-nhan">Đơn hàng của tôi</a>,
          icon: <ShoppingCartOutlined />
        },
        {
          key: 'my-book',
          label: <a href="/sach-cua-toi">Sách của tôi</a>,
          icon: <BookOutlined />
        },
        {
          key: 'affiliate',
          label: <a href="/tiep-thi-lien-ket">Tiếp thị liên kết</a>,
          icon: <BookOutlined />
        },
        {
          key: 'nhiem-vu-da-nop',
          label: <a href="/nhiem-vu-da-nop">Nhiệm vụ đã nộp</a>,
          icon: <UserAddOutlined />
        },
        {
          key: 'nhiem-vu-hoan-tien-da-nop',
          label: <a href="/nhiem-vu-hoan-tien-da-nop">Nhiệm vụ hoàn tiền đã nộp</a>,
          icon: <UserAddOutlined />
        },
        {
          key: 'change-password',
          label: <a href="/doi-mat-khau">Đổi mật khẩu</a>,
          icon: <UserAddOutlined />
        }
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); 

    useEffect(() => {
        if(!user?.user_id) {
            navigate("/dang-nhap");
            message.info("Bạn vui lòng đăng nhập để được dùng chức năng này!")
        }else {
            const query = `page=${paginationBook?.page}&pageSize=${paginationBook?.pageSize}&user_id=${user?.user_id}`;
            fetchAllByUser(query, setAffiliate, message);
        }
    }, [user]);

    return (
        <div className={`max-w-screen-2xl mx-auto my-5 ${isMobile && "pt-14"}`}>
            <div className="flex pb-4">
                <a href="">Trang chủ</a> 
                <p className="px-2">/</p> 
                <a href="">Thông tin cá nhân</a>
            </div>

            <Row>
                <Col xs={24} xl={4} className="p-1">
                    <Menu
                        className="w-full"
                        defaultSelectedKeys={['1']}
                        defaultOpenKeys={['sub1']}
                        mode="inline"
                        items={items}
                    />
                </Col>
                <Col xs={24} xl={20} className="p-1 bg-white">
                    <RowAffiliate affiliate={affiliate} pagination={paginationBook} setPagination={setPaginationBook} />
                </Col>
            </Row>
        </div>
    )
}